// GtLoader — the house loading state.
//
// Every screen used to write its own loading copy, which is how GtTable ended up
// hardcoding "Loading candidates…" and then showing it on the Clients and Roles
// tables too. The brand mark says nothing module-specific, so it cannot go stale
// or lie when a shared component is reused. Use this everywhere instead of text.
import mark from '../brand/favicon-black.png';

export default function GtLoader({ label, compact }) {
  return (
    <div className={'gtl' + (compact ? ' gtl--compact' : '')} role="status" aria-live="polite" aria-label="Loading">
      <div className="gtl-stage">
        <div className="gtl-mark"><img src={mark} alt="" /></div>
        <div className="gtl-shadow" />
      </div>
      {label ? <div className="gtl-label">{label}</div> : null}
    </div>
  );
}
